import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, PRICE, PRODUCT } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="ultima-pregunta" className="bg-night" data-id="element-54" data-mp="c8byj14ww7bg">
      <div className="mx-auto max-w-3xl px-3 py-8 text-center sm:px-6 sm:py-10" data-id="element-55" data-mp="844al66a2vea">
        <Reveal data-id="element-56" data-mp="m4f1g97l89zg">
          <h2 id="ultima-pregunta" className="font-display text-xl uppercase leading-tight text-volt sm:text-3xl" data-id="element-57" data-mp="m3wy6smicvi1">
            Una última pregunta
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-[0.85rem] leading-snug text-steel sm:text-base" data-id="element-58" data-mp="vtq8lqawz4kp">
            Dentro de unas semanas puedes seguir guardando videos y tratando de
            descubrir por tu cuenta qué aprender primero...{' '}
            <span className="font-bold text-white" data-id="element-59" data-mp="14td8g7nzw2bn">
              O puedes comenzar hoy siguiendo una ruta que va desde los
              fundamentos hasta el diagnóstico inicial.
            </span>
          </p>
          <p className="mt-2 font-script text-2xl leading-tight text-volt sm:text-3xl" data-id="element-60" data-mp="2h3rfievhj9d4">
            No necesitas saberlo todo para comenzar. Necesitas saber qué
            aprender primero.
          </p>
        </Reveal>

        <Reveal delay={0.05} className="mt-4 rounded-2xl border-2 border-volt bg-carbon p-4 sm:p-6" data-id="element-61" data-mp="2r2gotj9bflhr">
          <h3 className="font-display text-base uppercase leading-tight text-white sm:text-2xl" data-id="element-62" data-mp="2v2r5bpuqhuav">
            ⚡ {PRODUCT}
          </h3>
          <p className="mt-1 text-[0.72rem] font-extrabold uppercase tracking-[0.1em] text-steel sm:text-xs" data-id="element-63" data-mp="30093cl77qp43">
            Fundamentos • Herramientas • Instalaciones • Circuitos • Mediciones
            • Diagnóstico
          </p>
          <p className="mt-2 font-display text-base uppercase text-volt sm:text-xl" data-id="element-64" data-mp="3es1iaw33i15a">
            6 Tomos + 5 Bonos incluidos
          </p>
          <p className="mt-2 text-[0.75rem] font-bold uppercase text-steel sm:text-sm" data-id="element-65" data-mp="3itmqi44opr95">
            🎁 Valor de los bonos:{' '}
            <span className="line-through decoration-danger decoration-2" data-id="element-66" data-mp="1jlz3c670pppi">
              {BONUS_VALUE}
            </span>
          </p>
          <p className="text-[0.78rem] font-extrabold uppercase text-volt sm:text-sm" data-id="element-67" data-mp="1sgx0xql41qn6">
            🔥 Hoy los 5 bonos: Gratis
          </p>

          <p className="mt-3 text-[0.7rem] font-bold uppercase tracking-[0.24em] text-steel sm:text-xs" data-id="element-68" data-mp="1noneikj7f8pn">
            Precio especial:
          </p>
          <p className="font-display text-4xl leading-none text-white sm:text-5xl" data-id="element-69" data-mp="1xg9n0945qtop">
            ⚡ {PRICE} ⚡
          </p>
          <p className="text-[0.7rem] font-semibold uppercase tracking-wide text-steel sm:text-xs" data-id="element-70" data-mp="2behsj5f9f3bh">
            Pago único • Acceso Digital
          </p>

          <div className="mt-4 flex flex-col items-center gap-2" data-id="element-71" data-mp="h1i54q4n14tn">
            <CtaButton size="lg" data-id="element-72" data-mp="h20783dzed9h">🔥 COMIENZA HOY</CtaButton>
            <CtaButton size="lg" data-id="element-73" data-mp="d0et6eppnsxp">
              <ZapIcon size={18} className="mr-2 flex-shrink-0" strokeWidth={2.5} data-id="element-74" data-mp="d1hhcevnfh9x" />
              ¡SÍ! QUIERO EL SISTEMA COMPLETO POR {PRICE}
            </CtaButton>
            <p className="text-[0.7rem] font-semibold uppercase tracking-wide text-steel sm:text-xs" data-id="element-75" data-mp="6ze6u8t07w2d">
              Acceso Inmediato • Entrega Digital
            </p>
            <p className="flex items-center gap-1.5 text-[0.7rem] font-bold uppercase tracking-wide text-steel sm:text-xs" data-id="element-76" data-mp="3u92pzbwwe0m6">
              <ShieldCheckIcon size={14} className="text-volt" data-id="element-77" data-mp="3ffhfagrxxorr" />
              Garantía de Devolución de 30 Días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}